var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.49 3.85 1.42 1.42-5.31 5.3a.51.51 0 0 0 0 .71l2.12 2.12a.51.51 0 0 0 .71 0l5.3-5.31 1.42 1.42a.5.5 0 0 0 .85-.36V3.5a.5.5 0 0 0-.5-.5h-5.65a.5.5 0 0 0-.36.85Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 21h-17a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5Z"
})));
export default SvgExternalLink;